import { Grid } from '../../../../base';
import PersonalInfoCard from '../../PersonalInfoCard';
import CommentBox from '../../CommentBox';
import AIInsights from '../../AIInsights';
import EvaluatedSkills from '../../EvaluatedSkills';
import PDFViewerCard from '../../PDFViewerCard';
import {
    StyledAIInsightsSection,
    StyledEvaluatedSkillsSection,
} from './StepNewTemplate.styles';
import { IJobApplication } from '../../../../common';

interface StepNewTemplateProps {
    jobApplicationData: IJobApplication;
}

const StepNewTemplate = (props: StepNewTemplateProps) => {
    const { jobApplicationData } = props;
    return (
        <Grid container spacing={2}>
            <Grid
                container
                item
                xs={12}
                lg={7}
                columnSpacing={2}
                minHeight="100%"
            >
                {/*Left column*/}
                <Grid item xs={5} minHeight="100%">
                    <Grid
                        container
                        direction="column"
                        minHeight="100%"
                        rowSpacing={2}
                    >
                        <Grid item xs={4}>
                            <PersonalInfoCard
                                jobApplication={jobApplicationData}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <CommentBox
                                comments={jobApplicationData.comments}
                                isDisabled={jobApplicationData.isLegacy}
                            />
                        </Grid>
                    </Grid>
                </Grid>
                {/*middle column*/}
                <Grid
                    item
                    xs={7}
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                    }}
                >
                    <StyledAIInsightsSection item>
                        <AIInsights
                            insights={jobApplicationData?.insights}
                            isLegacy={jobApplicationData.isLegacy}
                        />
                    </StyledAIInsightsSection>
                    <StyledEvaluatedSkillsSection item>
                        <EvaluatedSkills
                            isEditable
                            requirements={jobApplicationData?.requirements}
                            questionAnswers={jobApplicationData?.questionAnswers}
                            isLegacy={jobApplicationData.isLegacy}
                        />
                    </StyledEvaluatedSkillsSection>
                </Grid>
            </Grid>
            {/*Right column*/}
            <Grid item xs={12} lg={5}>
                <PDFViewerCard url={jobApplicationData?.resumeUrl} />
            </Grid>
        </Grid>
    );
};

export default StepNewTemplate;
